export default __webpack_public_path__ + "static/img/self-bp-back.cc4d81b.jpg";